import React from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'
import autosize from 'autosize'
import LinnerDiv from './lineDiv'
import intialData, { localsMessages } from '../utility/getTemplateData'
import * as AppActions from '../actions/AppActions'

let messages = localsMessages('common/note')

class NoteComponent extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			donationNote: intialData.donationNote || '',
			height: 50
		};
	}

	componentDidMount () {
		if (intialData.donationNote) {
			$('.donate_note_wrapper label').hide()
			$('.donate_note_wrapper .note_wrap').show()
		}

		autosize(document.querySelector('textarea'));
	}

	handleClick = (event) => {
		$('.donate_note_wrapper label').hide()
		$('.donate_note_wrapper .note_wrap').show()
	}

	handleBlur = (event) => {
		if (event.target.value) {
			AppActions.changeNote({ note: event.target.value });
		} else {
			AppActions.changeNote({ note: '' });
			$('.donate_note_wrapper .note_wrap').hide()
			$('.donate_note_wrapper label').show()
		}
	}

	handleKeyPress = (event) => {
		if (event.target.value && event.target.value.length >= 250) {
			$('.note_wrap').addClass('animated shake');
			setTimeout(() => {
				$('.note_wrap').removeClass('animated shake');
			}, 1000);
			return false;
		}
	}

	renderSvgPencil () {
		return (
			<div style={{ width: 15, marginRight: 10, display: 'inline-block' }}>
				<svg style={{ display: 'inline', height: 14, width: 14, marginTop: 6, marginRight: 10, fill: 'none', stokeWidth: 1, stroke: 'grey' }} viewBox="0 0 14.2 14.22">
					<g>
						<polyline points="6.86 4.17 1.14 9.9 0.5 13.72 4.32 13.08 10.04 7.36"/>
						<path d="M5.14,14,3.23,12.14" transform="translate(-0.82 -0.96)"/>
						<path d="M12.61,6.57,9.43,3.39" transform="translate(-0.82 -0.96)"/>
						<path d="M10.86,2h0a1.89,1.89,0,0,1,2.66.11l.41.41A1.94,1.94,0,0,1,14,5.14h0" transform="translate(-0.82 -0.96)"/>
					</g>
				</svg>
			</div>
		)
	}

	render () {
		let { note: { label = '' } = {} } = messages;

		if (intialData.charityNoteEnabled && intialData.charityNoteLabel) {
			label = intialData.charityNoteLabel
		}

		return (
            <div>
				<div className="ppvx_row text-center donate_note_wrapper">
					<div className="note_wrap" style={{ width: '100%' }}>
						<textarea
							id="note"
							name="note"
							maxLength="250"
							style={{ height: this.state.height }}
							defaultValue={this.state.donationNote}
							onKeyPress={this.handleKeyPress}
							onBlur={this.handleBlur}>
						</textarea>
					</div>
					<label htmlFor="note"
						onClick={this.handleClick}>
						{this.renderSvgPencil()}
						<span>{label}</span>
					</label>
				</div>
				<LinnerDiv />
			</div>
		);
	}
}

NoteComponent.propTypes = {
	label: PropTypes.string
};

export default NoteComponent
